/**
 * Merkicoon: een betaalpas met magneetstrip, chip en euro-accent.
 * Kleuren volgen de design tokens (navy kaart, groene chip).
 */
export function BrandLogo({
  className = "h-9 w-9",
  inverted = false,
}: {
  className?: string;
  inverted?: boolean;
}) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="Casino Betalingen logo"
      focusable="false"
    >
      <rect
        width="64"
        height="64"
        rx="14"
        className={inverted ? "fill-primary-foreground/15" : "fill-primary"}
      />
      <rect x="10" y="17" width="44" height="30" rx="6" className="fill-primary-foreground" />
      <rect x="10" y="23" width="44" height="7" className="fill-primary" />
      <rect x="15" y="35" width="12" height="8" rx="2" className="fill-success" />
      <rect x="31" y="38" width="18" height="3" rx="1.5" className="fill-primary" opacity="0.35" />
    </svg>
  );
}
